import initialState from "./initialState";
import actionType from "../../actions/summary/actionType";

const summaryReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionType.GET_SUMMARY_CHAPTER: {
            return {
                ...state,
                chapterData: {
                    ...state.chapterData,
                    loading: true,
                    success: false,
                    error: false
                }
            }
        }
        case actionType.GET_SUMMARY_CHAPTER_SUCCESS: {
            return {
                ...state,
                chapterData: {
                    data: action.payload,
                    loading: false,
                    success: true,
                    error: false
                }
            }
        }
        case actionType.GET_SUMMARY_CHAPTER_FAILURE: {
            return {
                ...state,
                chapterData : {
                    ...state.chapterData,
                    loading: false,
                    success: false,
                    error: true
                }
            }
        }
        default:
            return state;
    }
};

export default summaryReducer;